export function toTitleCase(s?: string): string {
  return (s || '').toLowerCase().replace(/(^|\s)\S/g, c => c.toUpperCase());
}

// "MARIA GABRIELA DAVILA CARDENAS" -> "Maria Davila" (formato NOMBRES APELLIDOS de 4 palabras).
// Con 1-3 palabras el orden es ambiguo: se muestra el nombre completo en formato Título.
export function toCompactName(full?: string): string {
  const t = (full || '').trim().split(/\s+/).filter(Boolean);
  return t.length === 4 ? toTitleCase(`${t[0]} ${t[2]}`) : toTitleCase(t.join(' '));
}
